import { oList } from "constants/architectsTranslation";

function OListSection({ text }: oList) {
  return (
    <ol className="ps-3">
      {text.map((text, index) => (
        <li className="p-0" key={index}>
          {text}
        </li>
      ))}
    </ol>
  );
}

export default OListSection;
